import { Grid, GridCol } from "@naf/grid";
import { themeLight, fontStyle, spacing, borderRadius, breakpoints } from "@naf/theme";
import { nafColor } from "@nafcore/theme";
import { Text } from '@naf/text';
import styled from "styled-components";
export const Caption = styled.span.withConfig({
  displayName: "Styles__Caption",
  componentId: "sc-12oskpz-0"
})(["position:absolute;color:", ";", ";background-color:rgba(26,26,26,0.7);bottom:", ";margin:0 ", " 0 0;padding:0 ", ";border-radius:", ";z-index:3;grid-column:9 / 13;justify-self:end;@media (max-width:", "){grid-column:1 / -1;margin:0 ", ";}"], ({
  theme
}) => theme.typography ? theme.typography.defaultTextInverted : themeLight.typography.defaultTextInverted, fontStyle.article.caption, spacing.space20, spacing.space20, spacing.space8, borderRadius.M, breakpoints.s, spacing.space12);
export const StyledRunningHead = styled(Text).withConfig({
  displayName: "Styles__StyledRunningHead",
  componentId: "sc-12oskpz-1"
})(["text-shadow:0 2px 6px rgba(0,0,0,0.4);"]);
export const Header = styled(Grid).withConfig({
  displayName: "Styles__Header",
  componentId: "sc-12oskpz-2"
})(["grid-gap:", " !important;margin:auto;position:relative;align-items:flex-end;", " h1{margin-top:0;text-shadow:0 2px 6px rgba(0,0,0,0.4);}", " ", " @media (max-width:", "){min-height:80vh;", "}"], spacing.space24, ({
  $clickThroughHeader
}) => $clickThroughHeader ? 'pointer-events: none;' : '', props => props.mediaWidth ? `min-height: calc(${props.mediaWidth}px / 1.77778);` : 'min-height: 80vh;', props => props.videoHeight && `min-height: ${props.videoHeight}px;`, breakpoints.s, props => props.videoHeight && `min-height: ${props.videoHeight}px;`);
export const ImageWrapper = styled.div.withConfig({
  displayName: "Styles__ImageWrapper",
  componentId: "sc-12oskpz-3"
})(["position:absolute;top:0;width:100%;z-index:-50;border-radius:", ";", " ", " @media (max-width:", "){height:80vh;", "}"], borderRadius.S, ({
  $mediaWidth
}) => $mediaWidth ? `height: calc(${$mediaWidth}px / 1.77778);` : 'height: 80vh;', ({
  $videoHeight
}) => $videoHeight && `height: ${$videoHeight}px;`, breakpoints.s, ({
  $videoHeight
}) => $videoHeight && `height: ${$videoHeight}px;`);
export const StyledGridCol = styled(GridCol).withConfig({
  displayName: "Styles__StyledGridCol",
  componentId: "sc-12oskpz-4"
})(["color:#fff;grid-column:2 / 9;margin-bottom:", ";padding-bottom:", ";@media (max-width:", "){padding:0 ", ";grid-column:1 / -1;", "}"], spacing.space32, spacing.space64, breakpoints.s, spacing.space24, props => props.captionHeight ? `margin-bottom: calc(${spacing.space48} + ${props.captionHeight}px);` : `margin-bottom: ${spacing.space32};`);
export const Ingress = styled(Text).withConfig({
  displayName: "Styles__Ingress",
  componentId: "sc-12oskpz-5"
})(["grid-column:2 / 9;background-color:white;border-radius:", ";padding:", " ", ";height:fit-content;align-self:flex-end;position:absolute;left:-", ";", " ", " @media (max-width:", "){grid-column:2 / 11;}@media (max-width:", "){grid-column:1 / -1;padding:", " ", ";margin:", " 0;left:0;top:80vh;", "}"], borderRadius.M, spacing.space24, spacing.space32, spacing.space32, props => props.mediaWidth ? `top: calc((${props.mediaWidth}px / 1.77778) - 77px);` : 'top: calc(80vh - 77px);', props => props.videoHeight && `top: calc(${props.videoHeight}px - 77px);`, breakpoints.l, breakpoints.s, spacing.space16, spacing.space24, spacing.space8, props => props.videoHeight && `top: ${props.videoHeight}px;`);
export const YellowLine = styled.div.withConfig({
  displayName: "Styles__YellowLine",
  componentId: "sc-12oskpz-6"
})(["background-color:", ";width:94px;height:4px;"], nafColor.signature.yellow);
export const Image = styled.div.withConfig({
  displayName: "Styles__Image",
  componentId: "sc-12oskpz-7"
})(["& > img,& > video{width:100%;object-fit:cover;z-index:1;display:block;border-radius:", ";}", " ", " ", " img{border-style:hidden;border-radius:", ";", "}@media (max-width:", "){height:80vh;", " img{height:80vh;}}"], borderRadius.S, ({
  $overlay
}) => $overlay && `
    &:after {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: 
        radial-gradient(140.28% 84.01% at 54.18% 20.35%, rgba(0, 0, 0, 0.00) 49%, rgba(0, 0, 0, 0.08) 64%, rgba(0, 0, 0, 0.61) 100%),
        radial-gradient(218.33% 124.37% at 64.41% 0%, rgba(0, 0, 0, 0.00) 47%, rgba(0, 0, 0, 0.48) 100%);
      z-index: 50;
      border-radius: ${borderRadius.S};
    }
  `, ({
  $mediaWidth
}) => $mediaWidth ? `height: calc(${$mediaWidth}px / 1.77778);` : 'height: 80vh;', ({
  $videoHeight
}) => $videoHeight && `height: ${$videoHeight}px;`, borderRadius.S, ({
  $mediaWidth
}) => $mediaWidth ? `height: calc(${$mediaWidth}px / 1.77778);` : 'height: 80vh;', breakpoints.s, ({
  $videoHeight
}) => $videoHeight && `height: ${$videoHeight}px;`);
export const Wrapper = styled.div.withConfig({
  displayName: "Styles__Wrapper",
  componentId: "sc-12oskpz-8"
})(["position:relative;width:100%;margin-bottom:", ";z-index:5;", " ", " ", " @media (max-width:", "){", " ", "}"], spacing.space48, ({
  $subTextHeight
}) => $subTextHeight ? `height: calc(80vh + ${$subTextHeight}px - 77px);` : 'height: 80vh;', ({
  $subTextHeight,
  $mediaWidth
}) => $subTextHeight && $mediaWidth && `height: calc(((${$mediaWidth}px) / 1.77778) + ${$subTextHeight}px - 77px);`, ({
  $videoHeight,
  $subTextHeight
}) => $videoHeight && $subTextHeight && `height: calc(${$videoHeight}px + ${$subTextHeight}px - 77px);`, breakpoints.s, ({
  $subTextHeight
}) => $subTextHeight ? `height: calc(80vh + ${$subTextHeight}px);` : 'height: 80vh;', ({
  $videoHeight,
  $subTextHeight
}) => $videoHeight && $subTextHeight && `height: calc(${$videoHeight}px + ${$subTextHeight}px);`);
//# sourceMappingURL=Styles.js.map